export default "__VITE_ASSET__147c9102__"